export { default as LearnPage } from './learn-page';
export type { DataType } from './types';
